import { Redirect, useParams } from 'react-router'
import styled from 'styled-components'
import { useAuction } from '../../hooks/data/auction/useAuction'
import { BannerithDescription } from 'components/BannerithDescription'
import { Container as BaseContainer } from 'components/Container'
import { ProductList } from './ProductList'
import { Sidebar } from './Sidebar'
import { useAppTranslation } from '../../i18n/hooks'
import { useFilters } from './useFilters'
import { MainCategories } from './MainCategories'
import { useAuctionProducts } from 'hooks/data/auction/useAuctionProducts'
import { Loading, LoadingWrap as BaseLoadingWrap } from 'components/Shared/Loading'
import { useQuery } from 'hooks/query/useQuery'
import { useEffect, useMemo } from 'react'
import { useGetTranslated } from 'hooks/useGetTranslated'

export const Auction = () => {
  const { auctionId } = useParams()
  const { auction, loading: auctiuonLoading } = useAuction(auctionId)
  const { t } = useAppTranslation()
  const filters = useFilters(auction)
  const { products, loading: productsLoading } = useAuctionProducts(auctionId)
  const loading = auctiuonLoading || productsLoading
  const { page = 1 } = useQuery()
  const getTranslated = useGetTranslated()

  useEffect(() => {
    if (loading) {
      document.body.style.overflow = 'hidden'
      return
    }

    document.body.removeAttribute('style')
  }, [loading])

  const minHeight = useMemo(() => {
    if (!loading) return 0

    return window.innerWidth * 1.66 * page * 9
  }, [page, loading])

  if (loading)
    return (
      <Container minHeight={minHeight}>
        <LoadingWrap>
          <Loading />
        </LoadingWrap>
      </Container>
    )

  if (!auction) return <Redirect to="/not-found" />

  return (
    <Wrap>
      <BannerithDescription
        title={`Huutokauppa ${auction?.auctionId || ''}`}
        description={getTranslated(auction?.description) || ''}
        links={[
          { link: '/', label: t('home') },
          { link: `/auction/${auctionId}`, label: auction?.auctionId },
        ]}
      />
      {auction && <MainCategories auctionCategories={auction.categories} categories={filters.categoryOptions} />}
      <Container>
        <Sidebar {...filters} products={products} />
        <ProductList filters={filters} auctionHasEnded={!!auction?.liveAuctionEndedAt} products={products} />
        {loading && (
          <LoadingWrap>
            <Loading />
          </LoadingWrap>
        )}
      </Container>
    </Wrap>
  )
}

const Wrap = styled.div`
  background-color: var(--color-grey);
  padding-bottom: 5rem;
`
const Container = styled(BaseContainer)`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 1rem;
  position: relative;
  align-items: flex-start;
  align-content: flex-start;
  ${({ minHeight }) => minHeight && `min-height: ${minHeight}px;`}
  @media (min-width: 1024px) {
    max-width: 1200px;
  }

  @media (min-width: 767px) {
    flex-direction: row;
  }
`

const LoadingWrap = styled(BaseLoadingWrap)`
  position: fixed;
`
